import { User } from './security.models';
export let user: User = new User();